// import {
//     API_REQUEST, CREATED_BY_ASSEMBLY, GET_REPORT_LIST,
// } from '../../../config/constants';
// import { userDetails } from '../../../helper';

// const initialState = {
//     reportListing: []
// };

// export default function ReportListingReducers(state = initialState, action) {
//     switch (action.type) {
//         case API_REQUEST:
//             return {
//                 ...state,
//                 loading: true
//             };
//         case GET_REPORT_LIST:
//             let temp = action.payload
//             let Arr = []
//             let sr = 0
//             temp && temp.map(item => {
//                 if (item.Status === CREATED_BY_ASSEMBLY) {
//                     return false
//                 } else {
//                     item.PersonRequestingChange = userDetails().Name
//                     sr = ''
//                     item.SrNo = sr
//                     Arr.push(item)
//                     return Arr
//                 }
//             })
//             return {
//                 ...state,
//                 loading: false,
//                 reportListing: Arr
//             }

//         default:
//             return state;
//     }
// }



import {
    API_REQUEST, GET_REPORT_LIST, GET_ALL_REPORT_LIST, GET_BENCHMARK_MASTER_LIST, GET_COST_RATIO_REPORT, GET_REPORT_FORM_GRID_DATA, GET_PRODUCT_LIST, GET_PRODUCT_PART_DATA_LIST, GET_STAGE_OF_PART_DETAILS, GET_NFR_INSIGHT_DETAILS, GET_NFR_INSIGHT_STATUS_DETAILS,
    GET_BUSINESS_VALUE_REPORT_HEADS, GET_BUSINESS_VALUE_REPORT_DATA, SURFACE_TREATMENT_BUSINESS_VALUE_REPORT_DATA
} from '../../../config/constants';
import { userDetails, formatDecimalFields } from '../../../helper';

const initialState = {
    reportListing: [],
    allReportListing: [],
    costReportFormGridData: {},
    stageOfPartDetails: [],
    productList: [],
    productPartDataList: [],
    nfrInsightDetails: [],
    nfrInsightStatusDetails: []
};

// Decimal fields for Costing Breakup Report
const reportDecimalFields = [
    'RawMaterialScrapWeight', 'RawMaterialGrossWeight', 'RawMaterialFinishWeight',
    'NetRawMaterialsCost', 'NetBoughtOutPartCost', 'NetProcessCost', 'NetOperationCost',
    'SurfaceTreatmentCost', 'TransportationCost', 'NetSurfaceTreatmentCost', 'OverheadCombinedCost',
    'ProfitCost', 'NetOverheadAndProfitCost', 'RejectionCost', 'ICCInterestRate', 'NetICCCost',
    'PaymentTermCost', 'PackagingCost', 'FreightCost', 'ToolCost', 'ToolMaintenanceCost',
    'NetToolCost', 'HundiOrDiscountValue', 'AnyOtherCost', 'NetPOPriceOtherCurrency',
    'NetPOPriceINR', 'BasicRateLocalConversion', 'NetPOPriceLocalConversion',
    'BasicRateConversion', 'NetPOPriceConversion', 'BasicRate', 'NetConversionCost',
    'NetPOPrice', 'NetFreightPackagingCost', 'RawMaterialRate', 'ScrapRate',
    'NetLabourCost', 'IndirectLaborCost', 'StaffCost'
];

export default function ReportListingReducers(state = initialState, action) {
    switch (action.type) {
        case API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GET_REPORT_LIST:
            const formattedReportList = action.payload?.map(el => {
                const formatted = formatDecimalFields(el, reportDecimalFields);
                formatted.EffectiveDateNew = el.EffectiveDate;
                formatted.PersonRequestingChange = userDetails().Name;
                formatted.SrNo = '';
                return formatted;
            }) || [];
            return {
                ...state,
                loading: false,
                reportListing: formattedReportList
            }
        case GET_ALL_REPORT_LIST:
            const formattedAllReportList = action.payload?.map(el => {
                const formatted = formatDecimalFields(el, reportDecimalFields);
                formatted.EffectiveDateNew = el.EffectiveDate;
                formatted.PersonRequestingChange = userDetails().Name;
                formatted.SrNo = '';
                return formatted;
            }) || [];
            return {
                ...state,
                loading: false,
                allReportListing: formattedAllReportList
            }

        case GET_BENCHMARK_MASTER_LIST:
            return {
                ...state,
                loading: false,
                BenchmarkList: action.payload

            }
        case GET_COST_RATIO_REPORT:
            return {
                ...state,
                loading: false,
                costRatioReportList: action.payload
            }
        case GET_REPORT_FORM_GRID_DATA:
            return {
                ...state,
                loading: false,
                costReportFormGridData: action.payload
            }
        case GET_PRODUCT_LIST:
            return {
                ...state,
                loading: false,
                productList: action.payload
            }
        case GET_PRODUCT_PART_DATA_LIST:
            return {
                ...state,
                loading: false,
                productPartDataList: action.payload
            }
        case GET_STAGE_OF_PART_DETAILS:
            return {
                ...state,
                loading: false,
                stageOfPartDetails: action.payload
            }
        case GET_NFR_INSIGHT_DETAILS:
            return {
                ...state,
                loading: false,
                nfrInsightDetails: action.payload
            }
        case GET_NFR_INSIGHT_STATUS_DETAILS:
            return {
                ...state,
                loading: false,
                nfrInsightStatusDetails: action.payload
            }
        case GET_BUSINESS_VALUE_REPORT_HEADS:
            return {
                ...state,
                loading: false,
                businessValueReportHeads: action.payload
            }
        case GET_BUSINESS_VALUE_REPORT_DATA:
            return {
                ...state,
                loading: false,
                businessValueReportData: action.payload
            }
        case SURFACE_TREATMENT_BUSINESS_VALUE_REPORT_DATA:
            return {
                ...state,
                loading: false,
                surfaceTreatmentBusinessValueReportData: action.payload
            }

        default:
            return state;
    }
}
